// The same semantic colors apply to every EM²c building of each category.
// Only materials change: hex footprints, dimensions and connector geometry stay fixed.
export const COLONY_CATEGORY_COLORS = Object.freeze({
  core:          { body: "#42618b", accent: "#81b5ff", label: "Command & Comms" },
  habitation:    { body: "#327d72", accent: "#77e7bb", label: "Habitation" },
  medical:       { body: "#8c465c", accent: "#ff9bb5", label: "Medical & Safety" },
  life:          { body: "#497d36", accent: "#b5f078", label: "Life Support & Food" },
  power:         { body: "#a27b2d", accent: "#ffde65", label: "Power" },
  mining:        { body: "#916039", accent: "#ffb876", label: "Mining & Materials" },
  manufacturing: { body: "#815987", accent: "#e6a4f0", label: "Manufacturing" },
  storage:       { body: "#56717f", accent: "#a0cedd", label: "Logistics & Storage" },
  drones:        { body: "#396e9b", accent: "#71d4ff", label: "Drones & Vehicles" },
  spaceport:     { body: "#8b6650", accent: "#ffc79c", label: "Spaceport" },
  research:      { body: "#5264a0", accent: "#b0baff", label: "Research" },
  gas:           { body: "#317e8b", accent: "#66eced", label: "Gas & Propellant" },
});
export function getColonyCategoryColors(category) {
  return COLONY_CATEGORY_COLORS[category] || { body: "#3a3f4b", accent: "#00e5ff", label: "Other" };
}
